import { z } from "zod";

export const DischargeLetterCardiologyFormSchema = z.object({
  additional_diagnostic_findings: z.string().optional(),
  allergies: z.string().optional(),
  anamnesis: z.string().optional(),
  diagnoses: z.string().optional(),
  discharge_medications: z.string().optional(),
  ecg: z.string().optional(),
  other_information: z.string().optional(),
  physical_status: z.string().optional(),
  previous_diagnoses: z.string().optional(),
  social_history: z.string().optional(),
  therapy_and_course: z.string().optional(),
});
